// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1HVcR","alertIcon":"ConfirmModal_alertIcon__XHozN"};